import React, { useEffect, useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

const DialogUI = (props: UIProperties<DialogUIConfig>) => {
	const [forceUpdate, setForceUpdate] = useState(false);
	useEffect(() => {
		(props.parameters as any).onForceUpdate = () => {
			setForceUpdate(!setForceUpdate);
		}
	})
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			bottom: '40px',
			left: '50%',
			transform: 'translate(-50%, 0)',
			width: '1170px',
			height: '330px'
		}}>
			<div style={{
				position: 'absolute',
				top: '0',
				left: '0',
				width: '430px'
			}}>
				<img style={{
				}} src="./assets/images/dialog/bar_speech.png" />
				<p style={{
					position: 'absolute',
					top: '6px',
					left: '50px',
					margin: '0px',
					fontSize: '25pt'
				}} className="title-font">{props.parameters.speaker + ':'}</p>
			</div>

			<GeneralButtonWithText parameters= {{
				text: 'Next',
				top: '0',
				left: '980px',
				width: '195px',
				srcIdle: "./assets/images/dialog/button_next_2_main.png",
				srcHighlight: "./assets/images/dialog/button_next_2_down.png",
				onClicked: props.parameters.onNextClicked
			}}/>
			
			<div style={{
				position: 'absolute',
				top: '56px',
				left: '0',
				width: '100%',
				height: '270px',
				border: '3px solid rgb(192, 161, 6)',
				backgroundColor: 'rgb(36, 36, 36)'
			}}>
				{/* <img style={{
					width: '100%',
					height: '272px'
				}} src="./assets/images/dialog/dialog_bg.png" /> */}
				<div style={{
					position: 'absolute',
					top: '20px',
					left: '49px',
					width: '1075px',
					height: '220px',
					overflow: 'auto',
					pointerEvents: 'all'
				}}>
					<p style={{
						margin: '0px',
						fontSize: '25pt'
					}} className="title-font">{props.parameters.text}</p>
				</div>
			</div>
			
		</div>
	);

};

export interface DialogUIConfig extends BaseConfig{
	speaker: string;
	text: string;
	onNextClicked: () => void;
}

export default DialogUI;